/* OH_LENS_CONFIGURATOR_FLOW_V2 · 2026-07-21 */
(function () {
  'use strict';

  var SELECTOR_FOCUSABLE = [
    'a[href]', 'area[href]', 'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])',
    'textarea:not([disabled])', '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var COPY = {
    es: { appointmentDay: 'Día preferido para la llamada', appointmentTime: 'Hora preferida para la llamada', incomplete: 'Completa las opciones de este paso para continuar.', choose: 'Elige una opción para continuar.', route: 'Elige cómo quieres facilitarnos tu graduación.', rx: 'Introduce tu graduación, sube una receta o pide ayuda a un óptico.', add: 'En progresivos falta la Adición (ADD) de ambos ojos.', pdFormat: 'Formato de distancia pupilar', pdChoice: 'Indica si conoces tu distancia pupilar o si necesitas ayuda.', pdValue: 'Introduce una distancia pupilar válida o elige «Necesito ayuda».', heightChoice: 'Indica si conoces la altura de montaje o si necesitas ayuda.', heightValue: 'Introduce la altura de ambos ojos o elige «Necesito ayuda».', appointment: 'Elige día y hora, y aplica tu preferencia.', range: 'Introduce un valor entre {min} y {max}.', invalid: 'Revisa este valor antes de continuar.', upload: 'Subir receta: elige una imagen o un archivo PDF.', opened: 'Asistente de lentes abierto.', closed: 'Asistente de lentes cerrado.' },
    en: { appointmentDay: 'Preferred day for the call', appointmentTime: 'Preferred time for the call', incomplete: 'Complete the options in this step to continue.', choose: 'Choose an option to continue.', route: 'Choose how you want to provide your prescription.', rx: 'Enter your prescription, upload it, or ask an optician for help.', add: 'Progressive lenses need the Addition (ADD) for both eyes.', pdFormat: 'Pupillary distance format', pdChoice: 'Say whether you know your pupillary distance or need help.', pdValue: 'Enter a valid pupillary distance or choose “I need help”.', heightChoice: 'Say whether you know the fitting height or need help.', heightValue: 'Enter both fitting heights or choose “I need help”.', appointment: 'Choose a day and time, then apply your preference.', range: 'Enter a value between {min} and {max}.', invalid: 'Check this value before continuing.', upload: 'Upload prescription: choose an image or PDF file.', opened: 'Lens assistant opened.', closed: 'Lens assistant closed.' },
    fr: { appointmentDay: 'Jour souhaité pour l’appel', appointmentTime: 'Heure souhaitée pour l’appel', incomplete: 'Complétez les options de cette étape pour continuer.', choose: 'Choisissez une option pour continuer.', route: 'Choisissez comment nous transmettre votre ordonnance.', rx: 'Saisissez ou téléversez votre ordonnance, ou demandez de l’aide.', add: 'Les progressifs exigent l’Addition (ADD) des deux yeux.', pdFormat: 'Format de l’écart pupillaire', pdChoice: 'Indiquez si vous connaissez votre écart pupillaire ou avez besoin d’aide.', pdValue: 'Saisissez un écart valide ou choisissez « Besoin d’aide ».', heightChoice: 'Indiquez si vous connaissez la hauteur de montage ou avez besoin d’aide.', heightValue: 'Saisissez les deux hauteurs ou choisissez « Besoin d’aide ».', appointment: 'Choisissez le jour et l’heure, puis appliquez votre préférence.', range: 'Saisissez une valeur entre {min} et {max}.', invalid: 'Vérifiez cette valeur avant de continuer.', upload: 'Téléverser l’ordonnance : choisissez une image ou un PDF.', opened: 'Assistant verres ouvert.', closed: 'Assistant verres fermé.' },
    de: { appointmentDay: 'Gewünschter Tag für den Rückruf', appointmentTime: 'Gewünschte Uhrzeit für den Rückruf', incomplete: 'Vervollständigen Sie diesen Schritt, um fortzufahren.', choose: 'Wählen Sie eine Option, um fortzufahren.', route: 'Wählen Sie, wie Sie Ihr Rezept übermitteln möchten.', rx: 'Geben Sie Ihr Rezept ein, laden Sie es hoch oder bitten Sie um Hilfe.', add: 'Bei Gleitsicht fehlt die Addition (ADD) für beide Augen.', pdFormat: 'Format des Pupillenabstands', pdChoice: 'Geben Sie an, ob Sie Ihren Pupillenabstand kennen oder Hilfe brauchen.', pdValue: 'Geben Sie einen gültigen Pupillenabstand ein oder wählen Sie Hilfe.', heightChoice: 'Geben Sie an, ob Sie die Einschleifhöhe kennen oder Hilfe brauchen.', heightValue: 'Geben Sie beide Höhen ein oder wählen Sie Hilfe.', appointment: 'Wählen Sie Tag und Uhrzeit und übernehmen Sie Ihren Wunsch.', range: 'Geben Sie einen Wert zwischen {min} und {max} ein.', invalid: 'Prüfen Sie diesen Wert, bevor Sie fortfahren.', upload: 'Rezept hochladen: Bild oder PDF auswählen.', opened: 'Brillenglas-Assistent geöffnet.', closed: 'Brillenglas-Assistent geschlossen.' },
    ru: { appointmentDay: 'Предпочтительная дата звонка', appointmentTime: 'Предпочтительное время звонка', incomplete: 'Заполните параметры этого шага, чтобы продолжить.', choose: 'Выберите вариант, чтобы продолжить.', route: 'Выберите, как передать рецепт.', rx: 'Введите или загрузите рецепт либо попросите помощь.', add: 'Для прогрессивных линз нужна аддидация (ADD) обоих глаз.', pdFormat: 'Формат межзрачкового расстояния', pdChoice: 'Укажите, знаете ли вы межзрачковое расстояние.', pdValue: 'Введите верное значение или выберите помощь.', heightChoice: 'Укажите, знаете ли вы высоту установки.', heightValue: 'Введите обе высоты или выберите помощь.', appointment: 'Выберите дату и время и нажмите «Выбрать».', range: 'Введите значение от {min} до {max}.', invalid: 'Проверьте значение перед продолжением.', upload: 'Загрузите рецепт: выберите изображение или PDF.', opened: 'Помощник по линзам открыт.', closed: 'Помощник по линзам закрыт.' },
    zh: { appointmentDay: '首选通话日期', appointmentTime: '首选通话时间', incomplete: '请完成本步骤的选项以继续。', choose: '请选择一个选项以继续。', route: '请选择提供处方的方式。', rx: '请输入或上传处方，也可以向验光师寻求帮助。', add: '渐进镜片需要双眼的下加光（ADD）数据。', pdFormat: '瞳距格式', pdChoice: '请选择您是否知道瞳距，或是否需要帮助。', pdValue: '请输入有效瞳距，或选择“需要帮助”。', heightChoice: '请选择您是否知道装配高度，或是否需要帮助。', heightValue: '请输入双眼装配高度，或选择“需要帮助”。', appointment: '选择日期和时间，然后应用您的偏好。', range: '请输入 {min} 到 {max} 之间的数值。', invalid: '请检查该数值后再继续。', upload: '上传处方：请选择图片或 PDF 文件。', opened: '处方镜片助手已打开。', closed: '处方镜片助手已关闭。' }
  };

  /* OH_LENS_DRAFT_RESUME_V5: fail-closed, versioned and product-bound. */
  var DRAFT_KEY = 'oh_deferred_config';
  var DRAFT_VERSION = 5;
  var DRAFT_TTL = 14 * 24 * 60 * 60 * 1000;

  function clearDraft() {
    try { window.localStorage.removeItem(DRAFT_KEY); } catch (error) { /* unavailable */ }
  }

  function safeText(value, max) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value !== 'string' || value.length > max || value.trim() !== value || /[<>&"'`\\\u0000-\u001f]/.test(value)) {
      throw new Error('invalid draft text');
    }
    return value;
  }

  function choice(value, allowed, nullable) {
    if (nullable && (value === null || value === undefined || value === '')) return null;
    if (allowed.indexOf(value) === -1) throw new Error('invalid draft choice');
    return value;
  }

  function flag(value, nullable, fallback) {
    if (value === undefined && fallback !== undefined) return fallback;
    if (nullable && value === null) return null;
    if (value !== true && value !== false) throw new Error('invalid draft flag');
    return value;
  }

  function numberValue(value, min, max, increment, zeroAllowed) {
    if (typeof value !== 'number' || !isFinite(value)) throw new Error('invalid draft number');
    if (zeroAllowed && value === 0) return 0;
    if (value < min || value > max || (increment && Math.abs(value / increment - Math.round(value / increment)) > 0.000001)) {
      throw new Error('draft number out of range');
    }
    return value;
  }

  function appointment(value) {
    if (value === null || value === undefined) return null;
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('invalid appointment');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value.date || '') || !/^([01]\d|2[0-3]):[0-5]\d$/.test(value.time || '')) {
      throw new Error('invalid appointment value');
    }
    return { date: value.date, time: value.time };
  }

  function sanitizeDraft(state) {
    try {
      if (!state || typeof state !== 'object' || Array.isArray(state)) throw new Error('invalid draft state');
      var rx = state.rx;
      var pd = state.pd;
      var height = state.height;
      if (!rx || !rx.od || !rx.oi || !pd || !height) throw new Error('incomplete draft state');
      if (state.uploadedUrl) throw new Error('prescription uploads are not resumable');
      function eye(value) {
        return {
          sph: numberValue(value.sph, -20, 20, 0.25, true),
          cyl: numberValue(value.cyl, -6, 0, 0.25, true),
          axis: numberValue(value.axis, 0, 180, 1, true),
          add: numberValue(value.add, 0.5, 3.5, 0.25, true)
        };
      }
      var step = choice(state.step, [3, 8], false);
      var output = {
        step: step,
        mode: choice(state.mode, ['frame', 'own'], false),
        type: choice(state.type, ['Monofocal', 'Progresivo'], false),
        quality: safeText(state.quality, 64),
        index: safeText(state.index, 16),
        treatment: safeText(state.treatment, 96),
        filter: safeText(state.filter, 96),
        color: safeText(state.color, 96),
        cgroup: safeText(state.cgroup, 96),
        finishKey: safeText(state.finishKey, 96),
        acabado: safeText(state.acabado, 96),
        filterKey: safeText(state.filterKey, 96),
        usage: choice(state.usage, ['near', 'far', 'both', 'screens', 'sport', '__nograd__'], true),
        suggestBlueLight: flag(state.suggestBlueLight, false, false),
        noGrad: flag(state.noGrad, false, false),
        rx: { od: eye(rx.od), oi: eye(rx.oi) },
        pd: {
          type: choice(pd.type, ['single', 'dual'], false),
          single: numberValue(pd.single, 50, 80, 0.5, true),
          odPd: numberValue(pd.odPd, 25, 40, 0.5, true),
          oiPd: numberValue(pd.oiPd, 25, 40, 0.5, true)
        },
        dpKnown: flag(state.dpKnown, true),
        height: {
          od: numberValue(height.od, 10, 40, 0.5, true),
          oi: numberValue(height.oi, 10, 40, 0.5, true)
        },
        heightKnown: flag(state.heightKnown, true),
        rx_route: choice(state.rx_route, ['manual', 'photo', 'optico', 'later'], true),
        rx_appointment: appointment(state.rx_appointment),
        uploadedUrl: null,
        _customQuote: flag(state._customQuote, false, false),
        _estimatedPrice: state._estimatedPrice === null || state._estimatedPrice === undefined
          ? null : numberValue(state._estimatedPrice, 0, 5000, 0.01, false)
      };
      if (!output.quality || (output.noGrad && step === 3) || (output.noGrad && output.usage !== '__nograd__')) {
        throw new Error('incoherent draft route');
      }
      if (step === 8 && (!output.treatment || !output.cgroup || !output.acabado || !output.filterKey)) {
        throw new Error('incomplete summary draft');
      }
      return output;
    } catch (error) {
      return null;
    }
  }

  function readDraft(api) {
    try {
      var raw = window.localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      var payload = JSON.parse(raw);
      var now = Date.now();
      var timingOk = payload && typeof payload.ts === 'number' && typeof payload.expires === 'number' &&
        payload.ts <= now + 300000 && payload.expires > now && payload.expires - payload.ts <= DRAFT_TTL + 300000 && now - payload.ts <= DRAFT_TTL + 300000;
      if (!timingOk || payload.v !== DRAFT_VERSION || typeof payload.p !== 'string' || payload.p !== String(api.p || '') || payload.ctx !== window.location.pathname) {
        clearDraft();
        return null;
      }
      var state = sanitizeDraft(payload.state);
      if (!state) clearDraft();
      return state;
    } catch (error) {
      clearDraft();
      return null;
    }
  }

  function installDraftApi() {
    var api = window.OHLensDraftV5;
    if (!api || typeof api.restore !== 'function') return null;
    api.clear = clearDraft;
    api.read = function () { return readDraft(api); };
    return api;
  }

  installDraftApi();

  function init(root) {
    root = root || document;
    var overlay = root.querySelector ? root.querySelector('#ohLcOverlay') : null;
    if (!overlay || overlay.dataset.ohA11yBound === '1') return;
    overlay.dataset.ohA11yBound = '1';

    var modal = overlay.querySelector('.oh-lc-modal');
    var trigger = document.getElementById('ohLcTrigger');
    var draftApi = installDraftApi();
    var closeButton = document.getElementById('ohLcClose');
    var dialogTitle = overlay.querySelector('.oh-lc-header h2');
    var dialogDescription = overlay.querySelector('.oh-lc-header .oh-lc-product');
    var deferWrap = document.getElementById('ohWzDeferModal');
    var deferDialog = deferWrap && deferWrap.querySelector('[role="dialog"], .oh-modal');
    var lastFocus = null;
    var nestedLastFocus = null;
    var isOpen = false;
    var nestedOpen = false;
    var currentStep = null;
    var backgroundState = [];
    var bodyState = null;
    var enhanceQueued = false;
    var uid = 0;
    var lang = ((document.documentElement.lang || 'es').slice(0, 2)).toLowerCase();
    var text = COPY[lang] || COPY.es;

    if (!modal) return;
    ensureId(dialogTitle, 'ohLcDialogTitle');
    ensureId(dialogDescription, 'ohLcDialogDescription');
    setAttr(modal, 'role', 'dialog');
    setAttr(modal, 'aria-modal', 'true');
    setAttr(modal, 'aria-labelledby', dialogTitle && dialogTitle.id);
    if (dialogDescription) setAttr(modal, 'aria-describedby', dialogDescription.id);
    setAttr(modal, 'tabindex', '-1');
    setAttr(overlay, 'aria-hidden', overlay.classList.contains('oh-lc-open') ? 'false' : 'true');
    if (trigger) {
      setAttr(trigger, 'aria-haspopup', 'dialog');
      setAttr(trigger, 'aria-controls', 'ohLcOverlay');
      setAttr(trigger, 'aria-expanded', overlay.classList.contains('oh-lc-open') ? 'true' : 'false');
      trigger.addEventListener('pointerdown', rememberTrigger, { passive: true });
      trigger.addEventListener('keydown', rememberTrigger);
      trigger.addEventListener('click', function () {
        var draft = draftApi && draftApi.read();
        if (draft) draftApi.restore(draft);
      });
    }
    if (closeButton) setAttr(closeButton, 'type', 'button');

    var live = document.getElementById('ohLcA11yStatus');
    if (!live) {
      live = document.createElement('div');
      live.id = 'ohLcA11yStatus';
      live.className = 'oh-lc-sr-only';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      modal.appendChild(live);
    }

    var hint = null;
    ensureValidationHint();

    if (deferWrap && deferDialog) {
      setAttr(deferWrap, 'aria-hidden', deferWrap.hidden ? 'true' : 'false');
      setAttr(deferDialog, 'aria-modal', 'true');
      setAttr(deferDialog, 'role', 'dialog');
      setAttr(deferDialog, 'tabindex', '-1');
      var nestedTitle = deferDialog.querySelector('.t');
      ensureId(nestedTitle, 'ohWzDeferT');
      setAttr(deferDialog, 'aria-labelledby', nestedTitle && nestedTitle.id);
    }

    enhance();
    syncOpenState();
    if (trigger && window.location.hash === '#ohLcTrigger' && trigger.dataset.ohHashOpenedV5 !== '1') {
      trigger.dataset.ohHashOpenedV5 = '1';
      window.setTimeout(function () {
        safeFocus(trigger);
        if (!overlay.classList.contains('oh-lc-open')) trigger.click();
      }, 0);
    }

    var observer = new MutationObserver(function (mutations) {
      var needsEnhance = false;
      mutations.forEach(function (mutation) {
        if (mutation.target === overlay && mutation.attributeName === 'class') syncOpenState();
        if (deferWrap && mutation.target === deferWrap && mutation.attributeName === 'hidden') syncNestedState();
        needsEnhance = true;
      });
      if (needsEnhance) queueEnhance();
    });
    observer.observe(overlay, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled', 'aria-selected', 'aria-checked', 'aria-pressed']
    });

    // External PDP CTAs delegate to a hidden configurator trigger. Keep the
    // actual opener even on WebKit, where pointer clicks need not focus buttons.
    document.addEventListener('click', function (event) {
      var opener = event.target && event.target.closest && event.target.closest('[data-open-configurator]');
      if (opener && !overlay.contains(opener)) lastFocus = opener;
    }, true);
    document.addEventListener('keydown', onDocumentKeydown, true);
    // Let the browser perform its native Tab movement. Safari can still move
    // from a custom radio to BODY; contain only that escaped end state.
    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Tab' || !isOpen) return;
      var scope = nestedOpen && deferDialog ? deferDialog : modal;
      if (scope.contains(document.activeElement)) return;
      var items = visibleElements(scope.querySelectorAll(SELECTOR_FOCUSABLE)).filter(function (node) {
        return !node.closest('[inert]') && node.getAttribute('aria-hidden') !== 'true';
      });
      safeFocus((event.shiftKey ? items[items.length - 1] : items[0]) || scope);
    }, true);
    modal.addEventListener('keydown', onWidgetKeydown, true);
    modal.addEventListener('click', function (event) {
      var edit = event.target && event.target.closest && event.target.closest('.sum-sec-edit');
      if (!edit) return;
      var key = edit.getAttribute('data-review-focus');
      if (key === 'pd' || key === 'height') overlay.dataset.ohReviewEditTarget = key;
      else delete overlay.dataset.ohReviewEditTarget;
    }, true);
    modal.addEventListener('click', queueEnhance);
    modal.addEventListener('change', validateControl, true);
    modal.addEventListener('input', queueEnhance, true);
    modal.addEventListener('blur', validateControl, true);

    function rememberTrigger() {
      lastFocus = trigger || document.activeElement;
    }

    function syncOpenState() {
      var nowOpen = overlay.classList.contains('oh-lc-open');
      if (nowOpen === isOpen) return;
      isOpen = nowOpen;
      if (isOpen) openDialog(); else closeDialog();
    }

    function openDialog() {
      if (!lastFocus || !document.documentElement.contains(lastFocus)) lastFocus = document.activeElement || trigger;
      setAttr(overlay, 'aria-hidden', 'false');
      if (trigger) setAttr(trigger, 'aria-expanded', 'true');
      isolateBackground();
      lockScroll();
      window.setTimeout(function () {
        enhance();
        var heading = activeHeading() || dialogTitle || modal;
        if (heading !== modal) setAttr(heading, 'tabindex', '-1');
        safeFocus(heading);
        announce(text.opened);
      }, 0);
    }

    function closeDialog() {
      if (nestedOpen && deferWrap) {
        deferWrap.hidden = true;
        syncNestedState();
      }
      setAttr(overlay, 'aria-hidden', 'true');
      if (trigger) setAttr(trigger, 'aria-expanded', 'false');
      restoreBackground();
      unlockScroll();
      announce(text.closed);
      var destination = lastFocus && document.documentElement.contains(lastFocus) ? lastFocus : trigger;
      window.setTimeout(function () { safeFocus(destination); }, 0);
    }

    function syncNestedState() {
      if (!deferWrap || !deferDialog) return;
      var nowOpen = !deferWrap.hidden;
      setAttr(deferWrap, 'aria-hidden', nowOpen ? 'false' : 'true');
      if (nowOpen === nestedOpen) return;
      nestedOpen = nowOpen;
      if (nestedOpen) {
        nestedLastFocus = document.activeElement;
        var nestedTitle = deferDialog.querySelector('.t');
        if (nestedTitle) setAttr(nestedTitle, 'tabindex', '-1');
        window.setTimeout(function () { safeFocus(nestedTitle || firstFocusable(deferDialog) || deferDialog); }, 0);
      } else {
        var destination = nestedLastFocus && document.documentElement.contains(nestedLastFocus) ? nestedLastFocus : document.getElementById('ohWzDeferLink');
        window.setTimeout(function () {
          if ((document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1') && destination && !destination.getClientRects().length) destination = activeHeading();
          safeFocus(destination);
        }, 0);
      }
    }

    function onDocumentKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (nestedOpen && deferWrap) {
          deferWrap.hidden = true;
          syncNestedState();
        } else {
          overlay.classList.remove('oh-lc-open');
          syncOpenState();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      var scope = nestedOpen && deferDialog ? deferDialog : modal;
      trapTab(event, scope);
    }

    function onWidgetKeydown(event) {
      var target = event.target.closest && event.target.closest('[role="radio"], [role="button"]');
      if (!target) return;
      if ((event.key === 'Enter' || event.key === ' ') && !/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
        event.preventDefault();
        if (target.getAttribute('role') === 'radio') activateRadio(target);
        else target.click();
        return;
      }
      if (target.getAttribute('role') !== 'radio') return;
      var group = target.closest('[role="radiogroup"]');
      if (!group) return;
      var radios = visibleElements(group.querySelectorAll('[role="radio"]')).filter(function (node) {
        return node.getAttribute('aria-disabled') !== 'true';
      });
      if (!radios.length) return;
      var index = radios.indexOf(target);
      var nextIndex = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % radios.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + radios.length) % radios.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = radios.length - 1;
      else return;
      event.preventDefault();
      radios[nextIndex].tabIndex = 0;
      safeFocus(radios[nextIndex]);
      activateRadio(radios[nextIndex]);
    }

    function activateRadio(target) {
      var group = target.closest('[role="radiogroup"]');
      var step = target.closest('.oh-lc-step.active');
      var value = target.getAttribute('data-value');
      var label = (target.textContent || '').trim();
      target.click();
      // Keep keyboard focus on the same option after a synchronous redraw.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          enhance();
          if (!isOpen || !group || !group.isConnected ||
              (step && step !== modal.querySelector('.oh-lc-step.active'))) return;
          var active = document.activeElement;
          // Do not override a later Tab, a dialog transition, or another control.
          if (active !== document.body && active !== target && !group.contains(active)) return;
          var refreshed = visibleElements(group.querySelectorAll('[role="radio"]'));
          var selected = refreshed.find(function (node) {
            return node.getAttribute('aria-disabled') !== 'true' &&
              (value !== null ? node.getAttribute('data-value') === value : (node.textContent || '').trim() === label);
          });
          safeFocus(selected, true);
        });
      });
    }

    function enhance() {
      enhanceQueued = false;
      enhanceStandaloneSavedRxCopy();
      enhanceStandaloneClearFinish();
      enhanceStandaloneAdaptationScope();
      enhanceStandaloneQuoteDeadline();
      enhanceStandaloneSidePrice();
      enhanceStandaloneColorNames();
      enhanceStandaloneRecap();
      enhanceStandaloneStepHeadings();
      enhanceLabels();
      enhanceIntroPresentation();
      enhanceTreatmentGuidance();
      enhanceRadioGroups();
      enhanceRoutes();
      enhanceToggles();
      enhanceNavigation();
      enhanceReviewPresentation();
      enhanceSceneAvailability();
      enhanceUpload();
      enhanceValidationHint();
      syncNestedState();
      announceStepIfChanged();
    }

    // Preview availability only. Never infer or mutate prescription/price/selection state.
    var sceneLoads = Object.create(null);
    function enhanceSceneAvailability() {
      if (!(document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1')) return;
      var labels = {
        es:['Cargando vista previa…','Vista previa no disponible. Puedes seguir configurando tus lentes.','Reintentar'],
        en:['Loading preview…','Preview unavailable. You can continue configuring your lenses.','Try again'],
        fr:['Chargement de l’aperçu…','Aperçu indisponible. Vous pouvez continuer à configurer vos verres.','Réessayer'],
        de:['Vorschau wird geladen…','Vorschau nicht verfügbar. Sie können Ihre Gläser weiter konfigurieren.','Erneut versuchen'],
        ru:['Загрузка предпросмотра…','Предпросмотр недоступен. Вы можете продолжить настройку линз.','Повторить'],
        zh:['正在加载预览…','预览暂不可用。您可以继续配置镜片。','重试']
      };
      var copy = labels[lang] || labels.es;
      modal.querySelectorAll('.ohv3-stage').forEach(function(stage){
        if (stage.dataset.ohSceneStatus) return;
        var image = stage.querySelector('svg image');
        var source = image && image.getAttribute('href');
        if (!source) return;
        stage.dataset.ohSceneStatus = 'loading';
        stage.setAttribute('aria-busy','true');
        var status = document.createElement('p');
        status.className = 'oh-scene-status'; status.setAttribute('role','status');
        status.textContent = copy[0]; stage.appendChild(status);
        if (!sceneLoads[source]) {
          sceneLoads[source] = new Promise(function(resolve){
            var probe = new Image();
            var timeout = window.setTimeout(function(){resolve(false);},12000);
            probe.onload = function(){window.clearTimeout(timeout);resolve(true);};
            probe.onerror = function(){window.clearTimeout(timeout);resolve(false);};
            probe.src = source;
          });
        }
        sceneLoads[source].then(function(loaded){
          if (!stage.isConnected) return;
          stage.dataset.ohSceneStatus = loaded ? 'ready' : 'error';
          stage.setAttribute('aria-busy','false');
          if (loaded) {
            var restore=status.contains(document.activeElement);status.remove();
            if(restore){var caption=stage.nextElementSibling;if(caption){setAttr(caption,'tabindex','-1');safeFocus(caption);}}
          }
          else {
            status.textContent = copy[1];
            var retry=document.createElement('button');retry.type='button';retry.className='oh-scene-retry';retry.textContent=copy[2];
            retry.addEventListener('click',function(){
              delete sceneLoads[source];delete stage.dataset.ohSceneStatus;status.remove();
              image.setAttribute('href','');image.setAttribute('href',source);
              enhanceSceneAvailability();
              var pending=stage.querySelector('.oh-scene-status');if(pending){setAttr(pending,'tabindex','-1');safeFocus(pending);}
            });
            status.appendChild(retry);
          }
        });
      });
    }
    // First-step presentation only: retain native option values, prices and listeners.
    function enhanceIntroPresentation() {
      if (!(document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1')) return;
      var copy = {
        es:['Configura tus lentes','¿Para qué quieres usar las gafas?','Elige la opción que mejor se ajuste a tu uso habitual.',
          ['Para cerca','Leer el libro, el móvil, cocinar. A menos de 40 cm.'],['Para lejos','Conducir, ver la tele, mirar el paisaje.'],['Para ambos','Veo mal de lejos y de cerca. Una única gafa para todo.'],['Para pantallas','Trabajo muchas horas con el ordenador o el móvil.'],['Para deporte','Correr, bici, actividades al aire libre.'],['Sin graduación','Solo color y/o tratamiento, sin corrección visual']],
        en:['Configure your lenses','What will you use your glasses for?','Choose the option that best matches your everyday use.',
          ['For near vision','Reading, phone, cooking. Under 40 cm.'],['For distance','Driving, TV, looking at the landscape.'],['For both','I see poorly far and near. One pair for everything.'],['For screens','Many hours on computer or phone.'],['For sport','Running, cycling, outdoor activities.'],['No prescription','Colour and/or coating only, no vision correction']],
        fr:['Configurez vos verres','Pour quel usage souhaitez-vous vos lunettes ?','Choisissez l’option qui correspond le mieux à votre usage habituel.',
          ['Pour voir de près','Lire, utiliser le téléphone, cuisiner. À moins de 40 cm.'],['Pour voir de loin','Conduire, regarder la télévision ou le paysage.'],['De près et de loin','Je vois mal de loin et de près. Une seule paire pour les deux.'],['Pour les écrans','Je passe de nombreuses heures sur ordinateur ou téléphone.'],['Pour le sport','Course à pied, vélo, activités en plein air.'],['Sans correction','Couleur et/ou traitement uniquement, sans correction visuelle']],
        de:['Konfigurieren Sie Ihre Gläser','Wofür möchten Sie Ihre Brille nutzen?','Wählen Sie die Option, die am besten zu Ihrem Alltag passt.',
          ['Für die Nähe','Lesen, Smartphone, Kochen. Unter 40 cm Abstand.'],['Für die Ferne','Autofahren, Fernsehen, die Landschaft betrachten.'],['Für Nähe und Ferne','Ich sehe in der Ferne und Nähe schlecht. Eine Brille für beides.'],['Für Bildschirme','Ich verbringe viele Stunden am Computer oder Smartphone.'],['Für Sport','Laufen, Radfahren und Aktivitäten im Freien.'],['Ohne Sehstärke','Nur Farbe und/oder Beschichtung, ohne Sehkorrektur']],
        ru:['Настройте ваши линзы','Для чего вам нужны очки?','Выберите вариант, который лучше всего подходит для повседневного использования.',
          ['Для близи','Чтение, телефон, готовка. На расстоянии менее 40 см.'],['Для дали','Вождение, телевизор, рассматривание пейзажа.'],['Для близи и дали','Плохо вижу и вдаль, и вблизи. Одни очки для обоих случаев.'],['Для экранов','Много часов за компьютером или телефоном.'],['Для спорта','Бег, велосипед, занятия на открытом воздухе.'],['Без диоптрий','Только цвет и/или покрытие, без коррекции зрения']],
        zh:['配置您的镜片','您主要在什么场景使用眼镜？','请选择最符合您日常使用需求的选项。',
          ['看近处','阅读、看手机、烹饪。距离小于40厘米。'],['看远处','驾驶、看电视、看风景。'],['远近都需要','看远和看近都不清楚，希望用一副眼镜兼顾。'],['使用屏幕','长时间使用电脑或手机。'],['运动','跑步、骑行和户外活动。'],['无度数','仅选择颜色和／或镀膜，不矫正视力']]
      };
      var words = copy[lang] || copy.es;
      var mode = modal.querySelector('.oh-lc-step[data-step="0"]');
      var usage = modal.querySelector('.oh-lc-step[data-step="1"]');
      function writeText(node, value) {
        if (node && node.textContent !== value) node.textContent = value;
      }
      if (mode) writeText(mode.querySelector('h3.intro-h2'), words[0]);
      if (usage) {
        writeText(usage.querySelector('h3.intro-h2'), words[1]);
        writeText(usage.querySelector('.intro-sub'), words[2]);
      }
      var drawings = {
        near:'<path d="M12 5c-3-2-6-2-9-1v15c3-1 6-1 9 1 3-2 6-2 9-1V4c-3-1-6-1-9 1Zm0 0v15"/>',
        far:'<path d="M3 17h18M3 12l4-4 5 5 4-6 5 5"/><circle cx="6" cy="4" r="1"/>',
        both:'<rect x="2" y="9" width="8" height="7" rx="3"/><rect x="14" y="9" width="8" height="7" rx="3"/><path d="M10 12h4M2 11l2-6h2m16 6-2-6h-2"/>',
        screens:'<rect x="3" y="4" width="18" height="13" rx="1.5"/><path d="M8 21h8m-4-4v4"/>',
        sport:'<circle cx="6" cy="16" r="4"/><circle cx="18" cy="16" r="4"/><path d="m6 16 5-8 7 8m-12 0h8l-5-9H7m8-3h3l-3 5"/>',
        __nograd__:'<circle cx="12" cy="12" r="9"/><path d="M12 3v18m4-16-4 4m7-1-7 7m8-2-8 8"/>'
      };
      ['near','far','both','screens','sport','__nograd__'].forEach(function(value, i) {
        var option = modal.querySelector('#ohOptType .oh-lc-opt[data-value="'+value+'"]');
        if (!option) return;
        var name = option.querySelector('.oh-lc-opt-name');
        // Preserve any native badges/elements, replacing only the label text node.
        if (name) {
          var label = Array.prototype.find.call(name.childNodes,function(node){return node.nodeType===3;});
          if (label && label.nodeValue !== words[i+3][0]) label.nodeValue = words[i+3][0];
        }
        writeText(option.querySelector('.oh-lc-opt-desc'), words[i+3][1]);
        var icon = option.querySelector('.oh-lc-opt-icon');
        if (icon && icon.dataset.ohIntroIcon !== value) {
          icon.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'+drawings[value]+'</svg>';
          icon.dataset.ohIntroIcon = value;
          icon.setAttribute('aria-hidden','true');
        }
      });
    }

    function localizeReview(summary) {
      if (!summary || lang === 'es') return;
      var words = {
        en:['PD pending · you requested assistance','Fitting height pending · you requested assistance','pupillary distance','fitting height'],
        fr:['Écart pupillaire à confirmer · aide demandée','Hauteur de montage à confirmer · aide demandée','l’écart pupillaire','la hauteur de montage'],
        de:['Pupillendistanz ausstehend · Hilfe angefordert','Einschleifhöhe ausstehend · Hilfe angefordert','der Pupillendistanz','der Einschleifhöhe'],
        ru:['Межзрачковое расстояние не указано · запрошена помощь','Высота установки не указана · запрошена помощь','измерением межзрачкового расстояния','измерением высоты установки'],
        zh:['瞳距待确认 · 客户需要帮助','配装高度待确认 · 客户需要帮助','瞳距','配装高度']
      };
      var w=words[lang];if(!w)return;
      var pairs=[['DP pendiente · el cliente solicita ayuda',w[0]],['altura pendiente · el cliente solicita ayuda',w[1]],['distancia pupilar',w[2]],['altura de montaje',w[3]]];
      if(lang==='zh')pairs=pairs.concat([
        ['Revisión óptica obligatoria.','需要验光师审核。'],
        [' El equipo te ayudará con ','我们的团队会协助确认'],
        [' Este pedido queda bloqueado y nunca pasa a fabricación hasta que el equipo lo valide.','在团队审核通过前，订单将保持暂停状态，不会进入制作。'],
        [' Un óptico comprobará la receta y la compatibilidad.','验光师将核对处方和兼容性。'],
        ['Medidas completas y precio confirmado.','测量数据完整，价格已确认。'],
        [' La configuración cumple las reglas del catálogo y queda lista para la comprobación final.','配置符合产品目录规则，可进行最终核查。'],
        ['Sin tratamiento','无镀膜'],['Sin filtro adicional','不添加额外滤光']
      ]);
      var walker=document.createTreeWalker(summary,NodeFilter.SHOW_TEXT),node;
      while((node=walker.nextNode())){
        var original=node.nodeValue,value=original;
        pairs.forEach(function(pair){value=value.split(pair[0]).join(pair[1]);});
        if(value!==original)node.nodeValue=value;
      }
    }

    // OH_LENS_REVIEW_POLISH_20260910: display/focus only, no prescription or cart state.
    function enhanceReviewPresentation() {
      if (!(document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1')) return;
      var labels = {
        es:['Revisa tu selección','Simulación orientativa. No representa el resultado exacto de tus lentes.'],
        en:['Review your selection','Illustrative simulation. It does not show the exact result of your lenses.'],
        fr:['Vérifiez votre sélection','Simulation indicative. Elle ne représente pas le résultat exact de vos verres.'],
        de:['Prüfen Sie Ihre Auswahl','Unverbindliche Simulation. Sie zeigt nicht das genaue Ergebnis Ihrer Gläser.'],
        ru:['Проверьте выбор','Условная имитация. Она не показывает точный результат ваших линз.'],
        zh:['确认您的选择','此模拟仅供参考，不代表镜片的确切效果。']
      };
      var copy = labels[lang] || labels.es;
      var summary = modal.querySelector('#ohSummary');
      localizeReview(summary);
      if (summary && summary.children.length && !summary.parentElement.querySelector(':scope > h2, :scope > h3') && !summary.querySelector('h2, h3')) {
        var heading = document.createElement('h3');
        heading.className = 'oh-review-heading'; heading.textContent = copy[0];
        summary.insertBefore(heading, summary.firstChild);
      }
      modal.querySelectorAll('.ohv3-caption').forEach(function(caption){
        if (caption.querySelector('.oh-review-simulation')) return;
        var note = document.createElement('p');note.className='oh-review-simulation';note.textContent=copy[1];caption.appendChild(note);
      });
    }


    // OH_LENS_TREATMENT_GUIDANCE_20260915: explain the catalogue dependency.
    // Presentation only: data-value, click handlers, combinations and prices stay intact.
    function enhanceTreatmentGuidance() {
      if (!(document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1')) return;
      var copyByLanguage = {
        es: {
          help: 'Elige la protección de la superficie. El color, el acabado y el polarizado se seleccionan después; no todos los tratamientos ofrecen las mismas opciones.',
          none: 'Sin capas protectoras. Puede limitar el color y el acabado; para una lente de sol básica, elige «Endurecido».',
          hard: 'Protección antiarañazos. Es la opción base para añadir color, degradado, espejado o polarizado cuando estén disponibles.',
          ar: 'Antiarañazos + antirreflejante. Reduce reflejos en la superficie; el polarizado es un filtro distinto y se selecciona después.'
        },
        en: {
          help: 'Choose the surface protection. Tint, finish and polarization are selected later; not every treatment offers the same options.',
          none: 'No protective layers. This may limit tint and finish choices; for basic sunglasses, choose “Hardened”.',
          hard: 'Scratch protection. This is the base option for tint, gradient, mirror or polarized lenses when available.',
          ar: 'Scratch-resistant + anti-reflective. It reduces surface reflections; polarization is a separate filter selected later.'
        },
        fr: {
          help: 'Choisissez la protection de surface. La teinte, la finition et la polarisation se choisissent ensuite ; tous les traitements ne proposent pas les mêmes options.',
          none: 'Sans couche protectrice. Cela peut limiter les teintes et finitions ; pour un verre solaire basique, choisissez « Durci ».',
          hard: 'Protection anti-rayures. C’est l’option de base pour ajouter une teinte, un dégradé, un miroir ou une polarisation selon disponibilité.',
          ar: 'Anti-rayures + antireflet. Il réduit les reflets de surface ; la polarisation est un filtre distinct choisi ensuite.'
        },
        de: {
          help: 'Wählen Sie den Oberflächenschutz. Tönung, Ausführung und Polarisation folgen später; nicht jede Behandlung bietet dieselben Optionen.',
          none: 'Ohne Schutzschichten. Dadurch können Tönung und Ausführung eingeschränkt sein; für ein einfaches Sonnenglas wählen Sie „Gehärtet“.',
          hard: 'Kratzschutz. Dies ist die Basisoption für Tönung, Verlauf, Verspiegelung oder Polarisation, sofern verfügbar.',
          ar: 'Kratzfest + entspiegelt. Reduziert Oberflächenreflexe; Polarisation ist ein separater Filter und wird später gewählt.'
        },
        ru: {
          help: 'Выберите защиту поверхности. Цвет, отделка и поляризация выбираются дальше; набор вариантов зависит от обработки.',
          none: 'Без защитных слоёв. Это может ограничить цвет и отделку; для базовых солнцезащитных линз выберите «Закалённые».',
          hard: 'Защита от царапин. Базовый вариант для тонировки, градиента, зеркального или поляризационного фильтра при наличии.',
          ar: 'Защита от царапин + антибликовое покрытие. Поляризация — отдельный фильтр, который выбирается позже.'
        },
        zh: {
          help: '请选择镜片表面保护。颜色、外观和偏光将在后续步骤选择；不同处理提供的选项可能不同。',
          none: '不含保护镀层，可能会限制颜色和外观选项；如需基础太阳镜片，请选择“加硬”。',
          hard: '防刮保护。可在有货时选择染色、渐变、镜面或偏光的基础选项。',
          ar: '防刮加防反射。它用于减少镜片表面反射；偏光是另一种滤光功能，将在后续步骤选择。'
        }
      };
      var copy = copyByLanguage[lang] || copyByLanguage.es;
      var step = modal.querySelector('.oh-lc-step[data-step="4"]');
      if (!step) return;
      var help = step.querySelector('#ohHelpTreat4');
      if (help && help.textContent !== copy.help) help.textContent = copy.help;
      var descriptions = {
        'Sin tratamiento': copy.none,
        'Endurecido': copy.hard,
        'Endurecido + Antirreflejante': copy.ar
      };
      step.querySelectorAll('#ohOptTreatment .oh-lc-opt[data-value]').forEach(function (option) {
        var description = option.querySelector('.oh-lc-opt-desc');
        var wanted = descriptions[option.dataset.value];
        if (description && wanted && description.textContent !== wanted) description.textContent = wanted;
      });
    }

    function queueEnhance() {
      if (enhanceQueued) return;
      enhanceQueued = true;
      window.requestAnimationFrame(enhance);
    }

    // OH_STANDALONE_LOCALIZED_STEP_HEADINGS_V1: text only, reuse existing observer.
    // OH_STANDALONE_RECAP_LOCALE_V1: display text only; stored values unchanged.
    // OH_STANDALONE_{"en": {"Naranja": "Orange", "Rojo": "Red"}, "fr": {"Naranja": "Orange", "Rojo": "Rouge"}, "de": {"Naranja": "Orange", "Rojo": "Rot"}, "ru": {"Naranja": "Оранжевый", "Rojo": "Красный"}}_V1: two option names only, identifiers unchanged.
    function enhanceStandaloneSavedRxCopy() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var active = modal.querySelector('.oh-lc-step.active[data-step="3"]');
      var save = active && active.querySelector('#ohWzSaveRx');
      var copy = {
        es: ['Recordar mi graduación en este navegador', 'Conserva la graduación y las medidas introducidas en este navegador para próximas visitas.'],
        en: ['Remember my prescription in this browser', 'Keeps the entered prescription and measurements in this browser for future visits.'],
        fr: ['Mémoriser ma prescription dans ce navigateur', 'Conserve la prescription et les mesures saisies dans ce navigateur pour vos prochaines visites.'],
        de: ['Meine Sehstärke in diesem Browser merken', 'Speichert die eingegebene Sehstärke und Messwerte in diesem Browser für künftige Besuche.'],
        ru: ['Запомнить мой рецепт в этом браузере', 'Сохраняет введённый рецепт и измерения в этом браузере для следующих посещений.']
      }[lang];
      if (!save || !copy) return;
      var title = save.querySelector('.t');
      var description = save.querySelector('.d');
      if (title && title.textContent !== copy[0]) title.textContent = copy[0];
      if (description && description.textContent !== copy[1]) description.textContent = copy[1];
      if (description && description.style.display !== "block") description.style.display = "block";
    }

    var standaloneClearFinishOriginal = new WeakMap();
    function enhanceStandaloneClearFinish() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var active = modal.querySelector('.oh-lc-step.active[data-step="6"]');
      var selected = modal.querySelector('#ohOptFilter [role="radio"][aria-checked="true"]');
      var copy = {
        es: ['Acabado transparente', 'Sin tinte de color.', 'Acabado disponible para la lente transparente.'],
        en: ['Clear finish', 'No color tint.', 'Available finish for the clear lens.'],
        fr: ['Finition transparente', 'Sans teinte colorée.', 'Finition disponible pour le verre transparent.'],
        de: ['Klares Finish', 'Ohne Farbtönung.', 'Verfügbare Ausführung für das klare Glas.'],
        ru: ['Прозрачная линза', 'Без цветной тонировки.', 'Доступное исполнение для прозрачной линзы.']
      }[lang];
      if (!active || !selected || !copy) return;
      var clear = selected.getAttribute('data-value') === 'Transparente';
      var option = active.querySelector('#ohOptColor [role="radio"][data-value="uniforme"]');
      if (!option) return;
      var nodes = [option.querySelector('.oh-lc-opt-name'), option.querySelector('.oh-lc-opt-desc'), active.querySelector('#ohHelpAcabado')];
      nodes.forEach(function(node, i) {
        if (!node) return;
        if (clear) {
          if (!standaloneClearFinishOriginal.has(node)) standaloneClearFinishOriginal.set(node, node.textContent);
          if (node.textContent !== copy[i]) node.textContent = copy[i];
        } else if (standaloneClearFinishOriginal.has(node)) {
          node.textContent = standaloneClearFinishOriginal.get(node);
          standaloneClearFinishOriginal.delete(node);
        }
      });
    }

    var standaloneAdaptationOriginal = new WeakMap();
    function enhanceStandaloneAdaptationScope() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var active = modal.querySelector('.oh-lc-step.active[data-step="8"]');
      var selected = modal.querySelector('#ohOptType [role="radio"][aria-checked="true"]');
      if (!active || !selected) return;
      var noPrescription = selected.getAttribute('data-value') === '__nograd__';
      var claims = ['Garantía por inadaptación', 'Non-adaptation guarantee', 'Garantie d’inadaptation', 'Anpassungsgarantie', 'Гарантия адаптации'];
      active.querySelectorAll('.sum-trust-item').forEach(function(card) {
        var title = card.querySelector('.t');
        if (!title || claims.indexOf(title.textContent.trim()) === -1) return;
        if (noPrescription) {
          if (!standaloneAdaptationOriginal.has(card)) standaloneAdaptationOriginal.set(card, { hidden: card.hidden, display: card.style.getPropertyValue('display'), priority: card.style.getPropertyPriority('display') });
          if (!card.hidden) card.hidden = true;
          if (card.style.getPropertyValue('display') !== 'none' || card.style.getPropertyPriority('display') !== 'important') card.style.setProperty('display', 'none', 'important');
        } else if (standaloneAdaptationOriginal.has(card)) {
          var original = standaloneAdaptationOriginal.get(card);
          card.hidden = original.hidden;
          if (original.display) card.style.setProperty('display', original.display, original.priority);
          else card.style.removeProperty('display');
          standaloneAdaptationOriginal.delete(card);
        }
      });
    }

    var standaloneReadyOriginal = new WeakMap();
    function enhanceStandaloneQuoteDeadline() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var active = modal.querySelector('.oh-lc-step.active[data-step="8"]');
      if (!active) return;
      var ready = active.querySelector('.sum-hero-ready');
      if (!ready) return;
      var suppress = !!active.querySelector('.sum-banner--quote') && /5\s*[-–]\s*7/.test(ready.textContent);
      if (suppress) {
        if (!standaloneReadyOriginal.has(ready)) standaloneReadyOriginal.set(ready, { hidden: ready.hidden, display: ready.style.getPropertyValue('display'), priority: ready.style.getPropertyPriority('display') });
        if (!ready.hidden) ready.hidden = true;
        if (ready.style.getPropertyValue('display') !== 'none' || ready.style.getPropertyPriority('display') !== 'important') ready.style.setProperty('display', 'none', 'important');
      } else if (standaloneReadyOriginal.has(ready)) {
        var original = standaloneReadyOriginal.get(ready);
        ready.hidden = original.hidden;
        if (original.display) ready.style.setProperty('display', original.display, original.priority);
        else ready.style.removeProperty('display');
        standaloneReadyOriginal.delete(ready);
      }
    }

    var standaloneSideTotalLabel = null;
    function enhanceStandaloneSidePrice() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var active = modal.querySelector('.oh-lc-step.active');
      var total = modal.querySelector('#ohSideTotal');
      if (!active || !total) return;
      var step = Number(active.getAttribute('data-step'));
      var label = total.parentElement.querySelector('.lbl');
      if (label && ['es', 'en', 'fr', 'de', 'ru'].indexOf(lang) !== -1) {
        if (standaloneSideTotalLabel === null) standaloneSideTotalLabel = label.textContent;
        var subtotalLabel = step >= 4 && step <= 7 ? active.querySelector('#ohSpecsNote' + step + ' .lbl') : null;
        var labelText = subtotalLabel ? subtotalLabel.textContent : standaloneSideTotalLabel;
        if (label.textContent !== labelText) label.textContent = labelText;
      }
      var source = step === 8 ? active.querySelector('.sum-hero-price') :
        (step >= 4 && step <= 7 ? active.querySelector('#ohSpecsNote' + step + ' .price') : null);
      if (!source) return;
      var value = source.textContent.trim();
      if (!value) return;
      if (total.textContent !== value) total.textContent = value;
      // The legacy delta compares a different, incomplete selection; suppress it here.
      modal.querySelectorAll('.oh-lc-side-total .amt-delta').forEach(function(delta) {
        if (!delta.hidden) delta.hidden = true;
      });
    }

    function enhanceStandaloneColorNames() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var names = {"en": {"Naranja": "Orange", "Rojo": "Red"}, "fr": {"Naranja": "Orange", "Rojo": "Rouge"}, "de": {"Naranja": "Orange", "Rojo": "Rot"}, "ru": {"Naranja": "Оранжевый", "Rojo": "Красный"}}[lang];
      if (!names) return;
      modal.querySelectorAll('#ohOptFilter [role="radio"][data-value]').forEach(function(option) {
        var translated = names[option.getAttribute('data-value')];
        var title = option.querySelector('.oh-lc-opt-name');
        if (!translated || !title) return;
        var label = Array.prototype.find.call(title.childNodes, function(node) { return node.nodeType === 3; });
        if (label && label.nodeValue !== translated) label.nodeValue = translated;
      });
      modal.querySelectorAll('.ohv3-caption, #ohSummary .sum-hero-tint, #ohSummary .sum-sec-val').forEach(function(caption) {
        Array.prototype.forEach.call(caption.childNodes, function(node) {
          if (node.nodeType !== 3) return;
          var parts = node.nodeValue.split(' · ');
          if (!names[parts[0]]) return;
          parts[0] = names[parts[0]];
          var translated = parts.join(' · ');
          if (node.nodeValue !== translated) node.nodeValue = translated;
        });
      });
    }

    function enhanceStandaloneRecap() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var labels = {"en": {"selection": "Your selection", "Tipo": "Lens type", "Material": "Material", "Tratamiento": "Treatment", "Color": "Color", "Filtro": "Filter"}, "fr": {"selection": "Votre sélection", "Tipo": "Type de verre", "Material": "Matériau", "Tratamiento": "Traitement", "Color": "Couleur", "Filtro": "Filtre"}, "de": {"selection": "Ihre Auswahl", "Tipo": "Glasart", "Material": "Material", "Tratamiento": "Bearbeitung", "Color": "Farbe", "Filtro": "Filter"}, "ru": {"selection": "Ваш выбор", "Tipo": "Тип линзы", "Material": "Материал", "Tratamiento": "Обработка", "Color": "Цвет", "Filtro": "Фильтр"}}[lang];
      var values = {"en": {"Monofocal": "Single Vision", "Progresivo": "Progressive", "Base": "Basic", "Premium": "Premium", "Premium Plus": "Premium Plus", "Endurecido": "Hardened", "Endurecido + Antirreflejante": "Hardened + Anti-reflective", "Sin tratamiento": "No coating", "Sin filtro": "No filter", "Filtro Luz Azul": "Blue Light Filter", "Fotocromático": "Photochromic", "Color": "Tinted", "Espejado": "Mirror", "Optifog": "Optifog", "Terapéutico": "Therapeutic", "Sin color": "No colour", "Gris": "Grey", "Marrón": "Brown", "Negro": "Black", "Verde": "Green", "Negro degradado": "Gradient black", "Plata": "Silver", "Azul": "Blue", "Violeta": "Violet", "Mora": "Purple", "Naranja": "Orange", "Rojo": "Red", "Dorado": "Gold", "uniforme": "solid", "degradado": "gradient", "espejado": "Mirror"}, "fr": {"Monofocal": "Unifocal", "Progresivo": "Progressif", "Base": "Base", "Premium": "Premium", "Premium Plus": "Premium Plus", "Endurecido": "Durci", "Endurecido + Antirreflejante": "Durci + Antireflet", "Sin tratamiento": "Sans traitement", "Sin filtro": "Sans filtre", "Filtro Luz Azul": "Filtre lumière bleue", "Fotocromático": "Photochromique", "Color": "Teinté", "Espejado": "Miroité", "Optifog": "Optifog", "Terapéutico": "Thérapeutique", "Sin color": "Sans couleur", "Gris": "Gris", "Marrón": "Marron", "Negro": "Noir", "Verde": "Vert", "Negro degradado": "Noir dégradé", "Plata": "Argent", "Azul": "Bleu", "Violeta": "Violet", "Mora": "Violet", "Naranja": "Orange", "Rojo": "Rouge", "Dorado": "Doré", "uniforme": "uni", "degradado": "dégradé", "espejado": "Miroir"}, "de": {"Monofocal": "Einstärken", "Progresivo": "Gleitsicht", "Base": "Basis", "Premium": "Premium", "Premium Plus": "Premium Plus", "Endurecido": "Gehärtet", "Endurecido + Antirreflejante": "Gehärtet + Entspiegelt", "Sin tratamiento": "Ohne Beschichtung", "Sin filtro": "Ohne Filter", "Filtro Luz Azul": "Blaulichtfilter", "Fotocromático": "Photochrom", "Color": "Getönt", "Espejado": "Verspiegelt", "Optifog": "Optifog", "Terapéutico": "Therapeutisch", "Sin color": "Ohne Farbe", "Gris": "Grau", "Marrón": "Braun", "Negro": "Schwarz", "Verde": "Grün", "Negro degradado": "Schwarz verlaufend", "Plata": "Silber", "Azul": "Blau", "Violeta": "Violett", "Mora": "Lila", "Naranja": "Orange", "Rojo": "Rot", "Dorado": "Gold", "uniforme": "einfarbig", "degradado": "Verlauf", "espejado": "Verspiegelt"}, "ru": {"Monofocal": "Монофокальные", "Progresivo": "Прогрессивные", "Base": "Базовые", "Premium": "Премиум", "Premium Plus": "Премиум Плюс", "Endurecido": "Закалённые", "Endurecido + Antirreflejante": "Закалённые + Антибликовые", "Sin tratamiento": "Без покрытия", "Sin filtro": "Без фильтра", "Filtro Luz Azul": "Фильтр синего света", "Fotocromático": "Фотохромные", "Color": "Тонированные", "Espejado": "Зеркальные", "Optifog": "Optifog", "Terapéutico": "Терапевтические", "Sin color": "Без цвета", "Gris": "Серый", "Marrón": "Коричневый", "Negro": "Чёрный", "Verde": "Зелёный", "Negro degradado": "Чёрный градиент", "Plata": "Серебро", "Azul": "Синий", "Violeta": "Фиолетовый", "Mora": "Фиолетовый", "Naranja": "Оранжевый", "Rojo": "Красный", "Dorado": "Золото", "uniforme": "однотонный", "degradado": "градиент", "espejado": "Зеркальный"}}[lang];
      // Display the actual selected filter label, rather than the catalogue's internal fi value.
      var filterLabels = {"en": {"ninguno": "No additional filter", "polarizado": "Polarized", "fotocromatico": "Photochromic", "luz_azul": "Blue Light Filter", "optifog": "Optifog · Anti-fog", "terapeutico": "Therapeutic"}, "fr": {"ninguno": "Sans filtre", "polarizado": "Polarisé", "fotocromatico": "Photochromique", "luz_azul": "Filtre lumière bleue", "optifog": "Optifog · Antibuée", "terapeutico": "Thérapeutique"}, "de": {"ninguno": "Ohne Filter", "polarizado": "Polarisiert", "fotocromatico": "Photochrom", "luz_azul": "Blaulichtfilter", "optifog": "Optifog · Antibeschlag", "terapeutico": "Therapeutisch"}, "ru": {"ninguno": "Без фильтра", "polarizado": "Поляризованный", "fotocromatico": "Фотохромный", "luz_azul": "Фильтр синего света", "optifog": "Optifog · Антизапотевание", "terapeutico": "Терапевтический"}}[lang];
      var selectedFilter = modal.querySelector('#ohOptFiltro [role="radio"][aria-checked="true"]');
      var recap = modal.querySelector('#ohSideRecap');
      if (!labels || !values || !recap) return;
      var title = recap.querySelector('.oh-side-recap-h');
      if (title && title.textContent !== labels.selection) title.textContent = labels.selection;
      recap.querySelectorAll('.oh-side-recap-row').forEach(function(row) {
        var key = row.querySelector('.k');
        var value = row.querySelector('span:not(.k)');
        if (key && labels[key.textContent]) {
          var translatedKey = labels[key.textContent];
          if (key.textContent !== translatedKey) key.textContent = translatedKey;
        }
        if (value) {
          var translatedValue = value.textContent.split(' · ').map(function(part) {
            return values[part] || part;
          }).join(' · ');
          if (key && key.textContent === labels.Filtro && selectedFilter) {
            translatedValue = filterLabels[selectedFilter.getAttribute('data-value')] || translatedValue;
          }
          if (value.textContent !== translatedValue) value.textContent = translatedValue;
        }
      });
    }

    function enhanceStandaloneStepHeadings() {
      if (!overlay.closest('.oh-lens-page-section')) return;
      var copy = {
        en: ['Step ', ' of 4', 'Protection', 'Lens color', 'Finish', 'Extra filter'],
        fr: ['Étape ', ' sur 4', 'Protection', 'Couleur du verre', 'Finition', 'Filtre extra'],
        de: ['Schritt ', ' von 4', 'Schutz', 'Glasfarbe', 'Finish', 'Extra-Filter'],
        ru: ['Шаг ', ' из 4', 'Защита', 'Цвет линзы', 'Финиш', 'Доп. фильтр']
      }[lang];
      if (!copy) return;
      for (var step = 4; step <= 7; step++) {
        var heading = modal.querySelector('#ohSpecsEye' + step);
        var value = copy[0] + (step - 3) + copy[1] + ' · ' + copy[step - 2];
        if (heading && heading.textContent !== value) heading.textContent = value;
      }
    }

    function enhanceLabels() {
      modal.querySelectorAll('.oh-lc-rx-field').forEach(function (field) {
        var control = field.querySelector('input, select, textarea');
        var label = field.querySelector('label');
        if (!control) return;
        ensureId(control, 'ohLcField' + (++uid));
        if (label) {
          setAttr(label, 'for', control.id);
          label.querySelectorAll('.req').forEach(function (marker) {
            setAttr(marker, 'aria-hidden', 'true');
          });
          var eye = field.closest('.oh-lc-rx-eye');
          var eyeHeading = eye && eye.querySelector('h4');
          if (eyeHeading) {
            var eyeId = ensureId(eyeHeading, 'ohLcEye' + (++uid));
            var labelId = ensureId(label, control.id + 'Label');
            setAttr(eye, 'role', 'group');
            setAttr(eye, 'aria-labelledby', eyeId);
            setAttr(control, 'aria-labelledby', eyeId + ' ' + labelId);
            var icon = eyeHeading.querySelector('span');
            if (icon) setAttr(icon, 'aria-hidden', 'true');
          }
        }
        setAttr(control, 'autocomplete', 'off');
        if (label && label.querySelector('.req')) {
          setAttr(control, 'aria-required', 'true');
        }
        syncControlValidity(control, false);
      });
      [['ohWzCamInput', text.upload], ['ohWzFileInput', text.upload], ['ohRxFile', text.upload]].forEach(function (item) {
        var input = document.getElementById(item[0]);
        if (input) setAttr(input, 'aria-label', item[1]);
      });
    }

    function enhanceRadioGroups() {
      modal.querySelectorAll('.oh-lc-options, #ohLcIxSelector').forEach(function (group) {
        var options = group.querySelectorAll('.oh-lc-opt, .oh-lc-ix-opt');
        if (!options.length) return;
        setAttr(group, 'role', 'radiogroup');
        labelGroup(group);
        var hasSelected = !!group.querySelector('.selected');
        options.forEach(function (option, index) {
          var checked = option.classList.contains('selected');
          var disabled = option.classList.contains('disabled');
          setAttr(option, 'role', 'radio');
          setAttr(option, 'aria-checked', checked ? 'true' : 'false');
          setAttr(option, 'aria-disabled', disabled ? 'true' : 'false');
          option.tabIndex = checked || (!hasSelected && index === 0) ? 0 : -1;
        });
      });
    }

    function enhanceRoutes() {
      var group = document.getElementById('ohWzRoutes');
      if (!group) return;
      setAttr(group, 'role', 'group');
      labelGroup(group);
      group.querySelectorAll('.expanded-card-wrap').forEach(function (wrap, index) {
        var button = wrap.querySelector('.oh-option[data-route]');
        var panel = wrap.querySelector('.wz-expanded');
        if (!button || !panel) return;
        ensureId(button, 'ohLcRoute' + (++uid));
        ensureId(panel, button.id + 'Panel');
        var open = wrap.classList.contains('open');
        setAttr(button, 'role', null);
        setAttr(button, 'aria-checked', null);
        setAttr(button, 'aria-expanded', open ? 'true' : 'false');
        setAttr(button, 'aria-controls', panel.id);
        setAttr(panel, 'role', 'region');
        setAttr(panel, 'aria-labelledby', button.id);
        setAttr(panel, 'aria-hidden', open ? 'false' : 'true');
        panel.inert = !open;
        button.tabIndex = 0;
      });
    }

    function enhanceToggles() {
      modal.querySelectorAll('#ohPdKnow, #ohHeightKnow, .oh-lc-pd-type, .oh-date-strip, .oh-time').forEach(function (group) {
        var buttons = group.querySelectorAll('button');
        if (!buttons.length) return;
        setAttr(group, 'role', 'radiogroup');
        labelGroup(group);
        var hasActive = false;
        buttons.forEach(function (button) {
          var active = button.classList.contains('active') || button.getAttribute('aria-selected') === 'true' || button.getAttribute('aria-pressed') === 'true';
          hasActive = hasActive || active;
          setAttr(button, 'role', 'radio');
          setAttr(button, 'aria-checked', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });
        if (!hasActive && buttons[0]) buttons[0].tabIndex = 0;
      });
      var save = document.getElementById('ohWzSaveRx');
      if (save) setAttr(save, 'aria-label', (save.querySelector('.t') || save).textContent.trim());
    }

    function enhanceNavigation() {
      // P4d: only presentation; complete labels stay accessible and on desktop.
      if ((document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1')) {
        // OH_LENS_PROGRESS_20260910: use the same four stages as the visible rail.
        // Read presentation state only; never change the configurator's step or prices.
        var rail = modal.querySelector('#ohSideSteps');
        var stages = rail ? Array.from(rail.querySelectorAll('.oh-side-step')) : [];
        var activeStage = stages.findIndex(function(stage){return stage.classList.contains('active');});
        if (stages.length && activeStage >= 0) {
          var count = modal.querySelector('#ohSideXpCount');
          var value = (activeStage + 1) + ' / ' + stages.length;
          if (count && count.textContent !== value) count.textContent = value;
          var fill = modal.querySelector('#ohSideXpFill');
          var percentage = (stages.length > 1 ? Math.round(activeStage / (stages.length - 1) * 100) : 100) + '%';
          if (fill && fill.style.getPropertyValue('--pct') !== percentage) fill.style.setProperty('--pct', percentage);
          stages.forEach(function(stage){
            var label = stage.querySelector('.lbl');
            if (!label) return;
            var clean = label.textContent.replace(/^\s*\d+[.．]\s*/, '');
            if (clean !== label.textContent) label.textContent = clean;
          });
        }
        var compactLabels={es:['Uso','Receta','Lentes','Revisión'],en:['Needs','Prescription','Lenses','Review'],fr:['Besoins','Ordonnance','Verres','Vérifier'],de:['Bedarf','Rezept','Gläser','Prüfen'],ru:['Задача','Рецепт','Линзы','Проверка'],zh:['需求','验光单','镜片','确认']};
        var captions=compactLabels[lang]||compactLabels.es;
        modal.querySelectorAll('.oh-lc-plabel').forEach(function(label){
          if(label.querySelector('.oh-lc-plabel-short'))return;
          var original=label.textContent.trim();
          var caption=captions[parseInt(original,10)-1];
          if(!caption)return;
          var full=document.createElement('span');full.className='oh-lc-plabel-full';full.textContent=original;
          var short=document.createElement('span');short.className='oh-lc-plabel-short';short.textContent=caption;short.setAttribute('aria-hidden','true');
          label.replaceChildren(full,short);
        });
      }
      modal.querySelectorAll('.oh-lc-pstep.done, .oh-lc-pstep.active, .oh-side-step.done, .oh-side-step.active').forEach(function (step) {
        setAttr(step, 'role', 'button');
        step.tabIndex = 0;
        setAttr(step, 'aria-current', step.classList.contains('active') ? 'step' : null);
      });
    }

    function enhanceUpload() {
      var drop = document.getElementById('ohWzDrop');
      if (!drop) return;
      setAttr(drop, 'role', 'group');
      setAttr(drop, 'aria-label', text.upload);
      setAttr(drop, 'tabindex', null);
      var progress = document.getElementById('ohWzUploadProg');
      var bar = document.getElementById('ohWzUpFill');
      if (progress) {
        setAttr(progress, 'role', 'status');
        setAttr(progress, 'aria-live', 'polite');
      }
      if (bar) {
        var percentage = parseInt(bar.style.width, 10);
        setAttr(bar, 'role', 'progressbar');
        setAttr(bar, 'aria-valuemin', '0');
        setAttr(bar, 'aria-valuemax', '100');
        setAttr(bar, 'aria-valuenow', isNaN(percentage) ? '0' : String(percentage));
      }
    }

    function enhanceValidationHint() {
      ensureValidationHint();
      var next = document.getElementById('ohBtnNext');
      if (!next || !hint) return;
      var disabled = !!next.disabled;
      hint.textContent = validationMessage();
      hint.hidden = !disabled;
      setAttr(next, 'aria-disabled', disabled ? 'true' : 'false');
      setAttr(next, 'aria-describedby', disabled ? hint.id : null);
    }

    function ensureValidationHint() {
      var nav = document.getElementById('ohLcNav');
      if (!nav) return null;
      var connected = document.getElementById('ohLcValidationHint');
      if (connected) hint = connected;
      if (!hint || !hint.isConnected) {
        hint = document.createElement('p');
        hint.id = 'ohLcValidationHint';
        hint.className = 'oh-lc-validation-hint';
        hint.setAttribute('role', 'status');
        hint.setAttribute('aria-live', 'polite');
        hint.textContent = text.incomplete;
        hint.hidden = true;
      }
      if (hint.parentNode !== nav) nav.insertBefore(hint, nav.lastElementChild || null);
      return hint;
    }

    function validationMessage() {
      var active = modal.querySelector('.oh-lc-step.active');
      var step = active && active.getAttribute('data-step');
      if (step === '0' || step === '1' || step === '2' || step === '4' || step === '5' || step === '6' || step === '7') {
        return text.choose;
      }
      if (step !== '3') return text.incomplete;

      var routeButton = modal.querySelector('.oh-option[data-route][aria-expanded="true"], .expanded-card-wrap.open .oh-option[data-route]');
      var route = routeButton && routeButton.getAttribute('data-route');
      if (!route) return text.route;
      if (route === 'photo') {
        var file = document.getElementById('ohWzFileInput') || document.getElementById('ohRxFile');
        var uploadName = document.getElementById('ohRxFileName');
        var uploaded = !!(file && file.files && file.files.length) || !!(uploadName && uploadName.getClientRects().length && uploadName.textContent.trim());
        if (!uploaded) return text.upload;
      }
      if (route === 'optico') {
        var dateSelected = modal.querySelector('.oh-date-strip button.active, .oh-date-strip button[aria-checked="true"], .oh-date-strip button[aria-pressed="true"]');
        var timeSelected = modal.querySelector('.oh-time.active, .oh-time[aria-checked="true"], .oh-time button.active, .oh-time button[aria-checked="true"], .oh-time button[aria-pressed="true"]');
        var preferenceButton = modal.querySelector('#ohWzSlotBtn');
        if (!dateSelected || !timeSelected || !preferenceButton || !preferenceButton.disabled) return text.appointment;
      }
      if (route === 'manual') {
        var number = function (id) {
          var control = document.getElementById(id);
          return control ? (parseFloat(control.value) || 0) : 0;
        };
        var progressive = !!document.querySelector('.oh-lc-rx-add-row.show') || !!(document.getElementById('ohHeightSection') && window.getComputedStyle(document.getElementById('ohHeightSection')).display !== 'none');
        var hasDistancePower = [number('ohRxOdSph'), number('ohRxOiSph'), number('ohRxOdCyl'), number('ohRxOiCyl')].some(function (value) { return value !== 0; });
        var hasAdd = number('ohRxOdAdd') > 0 && number('ohRxOiAdd') > 0;
        if (!hasDistancePower && !(progressive && hasAdd)) return text.rx;
        if (progressive && !hasAdd) return text.add;
      }

      var pdYes = modal.querySelector('#ohPdKnow button[data-know="yes"].active, #ohPdKnow button[data-know="yes"][aria-checked="true"]');
      var pdNo = modal.querySelector('#ohPdKnow button[data-know="no"].active, #ohPdKnow button[data-know="no"][aria-checked="true"]');
      if (!pdYes && !pdNo) return text.pdChoice;
      if (pdYes) {
        var pdTypeDual = !!modal.querySelector('.oh-lc-pd-type button[data-pd="dual"].active, .oh-lc-pd-type button[data-pd="dual"][aria-checked="true"]');
        var pdSingle = parseFloat((document.getElementById('ohPdSingle') || {}).value) || 0;
        var pdOd = parseFloat((document.getElementById('ohPdOd') || {}).value) || 0;
        var pdOi = parseFloat((document.getElementById('ohPdOi') || {}).value) || 0;
        var pdValid = pdTypeDual ? (pdOd >= 25 && pdOd <= 40 && pdOi >= 25 && pdOi <= 40) : (pdSingle >= 50 && pdSingle <= 80);
        if (!pdValid) return text.pdValue;
      }

      var heightSection = document.getElementById('ohHeightSection');
      var progressiveHeight = !!(heightSection && window.getComputedStyle(heightSection).display !== 'none');
      if (progressiveHeight) {
        var heightYes = modal.querySelector('#ohHeightKnow button[data-know="yes"].active, #ohHeightKnow button[data-know="yes"][aria-checked="true"]');
        var heightNo = modal.querySelector('#ohHeightKnow button[data-know="no"].active, #ohHeightKnow button[data-know="no"][aria-checked="true"]');
        if (!heightYes && !heightNo) return text.heightChoice;
        if (heightYes) {
          var heightOd = parseFloat((document.getElementById('ohHeightOd') || {}).value) || 0;
          var heightOi = parseFloat((document.getElementById('ohHeightOi') || {}).value) || 0;
          if (!(heightOd >= 10 && heightOd <= 40 && heightOi >= 10 && heightOi <= 40)) return text.heightValue;
        }
      }
      return text.incomplete;
    }

    function validateControl(event) {
      var control = event.target;
      if (!control.matches || !control.matches('.oh-lc-rx-field input, .oh-lc-rx-field select')) return;
      syncControlValidity(control, true);
    }

    function syncControlValidity(control, announceError) {
      var field = control.closest('.oh-lc-rx-field');
      if (!field) return;
      var hasValue = String(control.value || '').trim() !== '';
      var invalid = hasValue && typeof control.checkValidity === 'function' && !control.checkValidity();
      setAttr(control, 'aria-invalid', invalid ? 'true' : 'false');
      var message = text.invalid;
      var validity = control.validity;
      if (invalid && validity && (validity.rangeUnderflow || validity.rangeOverflow) && control.min !== '' && control.max !== '') {
        message = text.range.replace('{min}', control.min).replace('{max}', control.max);
      }
      var error = field.querySelector('.oh-lc-field-error');
      if (invalid && !error) {
        error = document.createElement('span');
        error.className = 'oh-lc-field-error';
        error.id = control.id + 'Error';
        field.appendChild(error);
      }
      if (error) {
        if (error.textContent !== message) error.textContent = message;
        error.hidden = !invalid;
      }
      setDescription(control, invalid && error ? error.id : null);
      if (invalid && announceError) announce(message);
    }

    function announceStepIfChanged() {
      var active = modal.querySelector('.oh-lc-step.active');
      var step = active && active.getAttribute('data-step');
      if (!isOpen || step === null || step === currentStep) return;
      var previous = currentStep;
      currentStep = step;
      var heading = activeHeading();
      if (heading) announce(heading.textContent.trim());
      if (previous !== null && heading) {
        setAttr(heading, 'tabindex', '-1');
        window.setTimeout(function () {
          if ((document.body.classList.contains('oh-ed26') || overlay.getAttribute('data-oh-v3') === '1') && active === modal.querySelector('.oh-lc-step.active')) {
            var reader = document.getElementById('ohLcBody');
            if (reader) reader.scrollTop = 0;
          }
          var reviewKey = overlay.dataset.ohReviewEditTarget;
          delete overlay.dataset.ohReviewEditTarget;
          var measurementHeading = step === '3' && active === modal.querySelector('.oh-lc-step.active') && ['pd','height'].indexOf(reviewKey) !== -1 ? active.querySelector('[data-mv3="' + reviewKey + '_title"]') : null;
          var key = overlay.dataset.ohGuidedEditTarget;
          var field = key && ['use','look','rx','color','finish','notes'].indexOf(key) !== -1 && active === modal.querySelector('.oh-lc-step.active') && overlay.classList.contains('oh-guided-flow') ? active.querySelector('#ohGuided-' + key) : null;
          if (field) {
            var detail = field.closest('details');
            if (detail) detail.open = true;
            var target = field.tagName === 'FIELDSET' ? field.querySelector('input:checked') || field.querySelector('input') : field;
            delete overlay.dataset.ohGuidedEditTarget;
            safeFocus(target);
            if (target) target.scrollIntoView({block:'center',behavior:'auto'});
          } else if (measurementHeading && visibleElements([measurementHeading]).length) {
            setAttr(measurementHeading, 'tabindex', '-1');
            safeFocus(measurementHeading);
            measurementHeading.scrollIntoView({block:'center',behavior:'auto'});
          } else safeFocus(heading);
        }, 0);
      }
    }

    function activeHeading() {
      var active = modal.querySelector('.oh-lc-step.active');
      var heading = active && visibleElements(active.querySelectorAll('h1,h2,h3,[role="heading"]'))[0];
      if (heading && heading.tagName === 'H2') setAttr(heading, 'aria-level', '3');
      return heading || null;
    }

    function isolateBackground() {
      if (backgroundState.length) return;
      var node = overlay;
      while (node && node !== document.body) {
        var parent = node.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === node || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          backgroundState.push({
            node: sibling,
            inert: !!sibling.inert,
            ariaHidden: sibling.getAttribute('aria-hidden')
          });
          sibling.inert = true;
          sibling.setAttribute('aria-hidden', 'true');
        });
        node = parent;
      }
    }

    function restoreBackground() {
      backgroundState.forEach(function (state) {
        if (!state.node || !document.documentElement.contains(state.node)) return;
        state.node.inert = state.inert;
        if (state.ariaHidden === null) state.node.removeAttribute('aria-hidden');
        else state.node.setAttribute('aria-hidden', state.ariaHidden);
      });
      backgroundState = [];
    }

    function lockScroll() {
      if (bodyState) return;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      bodyState = {
        y: y,
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };
      document.documentElement.classList.add('oh-lc-scroll-lock');
      document.body.classList.add('oh-lc-scroll-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + y + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      if (!bodyState) return;
      var saved = bodyState;
      bodyState = null;
      document.documentElement.classList.remove('oh-lc-scroll-lock');
      document.body.classList.remove('oh-lc-scroll-lock');
      document.body.style.position = saved.position;
      document.body.style.top = saved.top;
      document.body.style.left = saved.left;
      document.body.style.right = saved.right;
      document.body.style.width = saved.width;
      document.body.style.overflow = saved.overflow;
      window.scrollTo(0, saved.y);
    }

    function trapTab(event, scope) {
      var focusable = visibleElements(scope.querySelectorAll(SELECTOR_FOCUSABLE)).filter(function (node) {
        return !node.closest('[inert]') && node.getAttribute('aria-hidden') !== 'true';
      });
      if (!focusable.length) {
        event.preventDefault();
        safeFocus(scope);
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!scope.contains(document.activeElement)) {
        event.preventDefault();
        safeFocus(event.shiftKey ? last : first);
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        safeFocus(last);
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        safeFocus(first);
      }
    }

    function firstFocusable(scope) {
      return visibleElements(scope.querySelectorAll(SELECTOR_FOCUSABLE))[0] || null;
    }

    function labelGroup(group) {
      if (group.matches('.oh-date-strip, .oh-time')) {
        setAttr(group, 'aria-labelledby', null);
        setAttr(group, 'aria-label', group.matches('.oh-date-strip') ? text.appointmentDay : text.appointmentTime);
        return;
      }
      if (group.matches('.oh-lc-pd-type')) {
        setAttr(group, 'aria-labelledby', null);
        setAttr(group, 'aria-label', text.pdFormat);
        return;
      }
      var measurement = group.closest('.oh-measures-v3-section');
      var measurementHeading = measurement && measurement.querySelector('h4');
      if (measurementHeading) {
        ensureId(measurementHeading, 'ohLcMeasurementHeading' + (++uid));
        setAttr(group, 'aria-labelledby', measurementHeading.id);
        return;
      }
      if (group.hasAttribute('aria-label') || group.hasAttribute('aria-labelledby')) return;
      var step = group.closest('.oh-lc-step');
      var heading = step && step.querySelector('h2, h3, h4');
      if (heading) {
        ensureId(heading, 'ohLcHeading' + (++uid));
        setAttr(group, 'aria-labelledby', heading.id);
      }
    }

    function announce(message) {
      if (!live || !message) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = message; }, 20);
    }
  }

  function visibleElements(nodes) {
    return Array.prototype.filter.call(nodes, function (node) {
      if (!node || node.hidden) return false;
      var style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
    });
  }

  function ensureId(node, fallback) {
    if (!node) return null;
    if (!node.id) node.id = fallback;
    return node.id;
  }

  function setAttr(node, name, value) {
    if (!node) return;
    if (value === null || value === undefined || value === '') {
      if (node.hasAttribute(name)) node.removeAttribute(name);
      return;
    }
    value = String(value);
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function setDescription(control, id) {
    var current = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    current = current.filter(function (token) { return !/Error$/.test(token); });
    if (id && current.indexOf(id) === -1) current.push(id);
    setAttr(control, 'aria-describedby', current.length ? current.join(' ') : null);
  }

  function safeFocus(node, revealInAssistant) {
    if (!node || typeof node.focus !== 'function') return;
    try { node.focus({ preventScroll: true }); } catch (error) { node.focus(); }
    if (!revealInAssistant || !node.isConnected) return;
    var scroller = node.closest('#ohLcBody');
    if (!scroller) return;
    var bounds = scroller.getBoundingClientRect();
    var target = node.getBoundingClientRect();
    var margin = 6;
    var visibleTop = bounds.top + margin;
    var visibleBottom = bounds.bottom - margin;
    var parts = scroller.querySelector('.oh-flow-parts');
    if (parts && parts.getClientRects().length && !parts.contains(node)) {
      var partsStyle = window.getComputedStyle(parts);
      if (partsStyle.position === 'sticky' || partsStyle.position === 'fixed') {
        visibleTop = Math.max(visibleTop, parts.getBoundingClientRect().bottom + margin);
      }
    }
    if (visibleBottom <= visibleTop) return;
    if (target.height > visibleBottom - visibleTop || target.top < visibleTop) {
      scroller.scrollTo({ top: scroller.scrollTop + target.top - visibleTop, behavior: 'instant' });
    } else if (target.bottom > visibleBottom) {
      scroller.scrollTo({ top: scroller.scrollTop + target.bottom - visibleBottom, behavior: 'instant' });
    }
  }

  function start() {
    init(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();
